module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg1@2x.123b9f0c.png";